import { Directive } from '@angular/core';
import { IfStoreDirectiveDef } from '@df/ui/if-store.directive.def';
@Directive({ selector: '[ifStore]', standalone: true })
export class IfStoreDirective extends IfStoreDirectiveDef {}
